import { render, staticRenderFns } from "./IssueMain.vue?vue&type=template&id=17953cd1&scoped=true&"
import script from "./IssueMain.vue?vue&type=script&lang=js&"
export * from "./IssueMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17953cd1",
  null
  
)

export default component.exports